import Select from './Select';
import { getTimeZones } from '@vvo/tzdb';
import SelectOptgroup from './SelectOptgroup.jsx';

let optionsCache = null;

function getOptions() {
    // Don't recalc every render!
    if (optionsCache === null) {
        const timeZonesWithUtc = getTimeZones({ includeUtc: true });

        const optgroupOptions = {};
        timeZonesWithUtc
            .sort((a, b) => {
                // First, sort by offset
                return (
                    b.currentTimeOffsetInMinutes - a.currentTimeOffsetInMinutes
                );
            })
            .sort((a, b) => {
                // Then order so US is first
                if (a.countryCode === 'US' && b.countryCode !== 'US') {
                    return -1;
                } else {
                    return 0;
                }
            })
            .forEach(opt => {
                // optgroupOptions.push({
                //     key: opt.name,
                //     label: `GMT${opt.currentTimeFormat}`
                // })
                optgroupOptions[opt.countryCode] = {
                    label: opt.countryName,
                    options: {
                        ...optgroupOptions[opt.countryCode]?.options,
                        [opt.name]: `GMT${opt.currentTimeFormat}`,
                    },
                };
            });
        //.forEach((opt) => keyedOptions[opt.name] = `GMT${opt.currentTimeFormat}`)
        optionsCache = optgroupOptions;
    }

    return optionsCache;
}

let canonicalNameCache = null;

/**
 * Browsers can report a time zone alias (e.g. Asia/Calcutta) that isn't one of
 *  the options, which would leave the select showing the wrong zone. Map it back
 *  to the name the options use.
 */
export function canonicalTimezoneName(timezone) {
    if (!timezone) {
        return timezone;
    }

    if (canonicalNameCache === null) {
        canonicalNameCache = {};
        const timeZones = getTimeZones({ includeUtc: true });
        // Names of actual options first so an alias never overwrites one
        timeZones.forEach(tz => (canonicalNameCache[tz.name] = tz.name));
        timeZones.forEach(tz =>
            (tz.group || []).forEach(name => {
                if (!canonicalNameCache[name]) {
                    canonicalNameCache[name] = tz.name;
                }
            }),
        );
    }

    return canonicalNameCache[timezone] || timezone;
}

const TimezoneSelect = ({
    value,
    onChange,
    label,
    id,
    className,
    inputClassName,
}) => {
    const optgroupOptions = getOptions();

    return (
        <SelectOptgroup
            id={id}
            label={label}
            className={className}
            value={canonicalTimezoneName(value)}
            onChange={onChange}
            options={Object.values(optgroupOptions)}
            inputClassName={inputClassName}
        />
    );
};

export default TimezoneSelect;
